"use client";

import * as React from "react";

export const MOBILE_BREAKPOINT = 1024;
export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

const getCurrentIsMobile = () => {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return undefined;
  }

  return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
};

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    getCurrentIsMobile
  );

  React.useEffect(() => {
    if (typeof window.matchMedia !== "function") {
      setIsMobile(false);
      return;
    }

    const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    setIsMobile(mql.matches);

    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", onChange);

      return () => mql.removeEventListener("change", onChange);
    }

    mql.addListener(onChange);

    return () => mql.removeListener(onChange);
  }, []);

  return !!isMobile;
}
